<template>
  <v-tooltip top :disabled="!tooltip">
    <template v-slot:activator="{ on }">
      <v-fab-transition>
        <v-btn
          v-if="icon"
          v-on="on"
          v-show="!hidden"
          :to="link || null"
          @click="!link ? onClick() : false"
          :color="color"
          :loading="loading"
          fab
          fixed
          bottom
          right
          dark
        >
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </v-fab-transition>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CPTFlyBtn",
  props: {
    icon: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: ""
    },
    hidden: {
      type: Boolean,
      default: false
    },
    link: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: "primary"
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>
